import { render, staticRenderFns } from "./UiCInputRadioGroup.vue?vue&type=template&id=54fdeeb9&"
import script from "./UiCInputRadioGroup.vue?vue&type=script&lang=js&"
export * from "./UiCInputRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports